import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import _isEqual from "lodash/isEqual";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.anchor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import { Editor, Range, Element as SlateElement, Transforms } from 'slate';
import { remarkToSlate, slateToRemark } from '@applyboard/remark-slate-transformer';
import { isArray } from "../../utils/isArray";
import { assert } from "../../utils";
import { produce } from 'immer';
import unified from 'unified';
import remarkParse from 'remark-parse';
import visit from 'unist-util-visit';
import stringify from 'remark-stringify';
import isHotkey from 'is-hotkey';
var LIST_TYPES = ['ol', 'ul'];
var HEADING_TYPES = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
export function toggleBlock(editor, format) {
  var isActive = isBlockActive(editor, format);
  var isList = LIST_TYPES.includes(format);
  var isHeading = HEADING_TYPES.includes(format);
  Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return !Editor.isEditor(n) && SlateElement.isElement(n) && LIST_TYPES.includes(n.type);
    },
    split: true
  });
  var newProperties;
  if (isHeading) {
    newProperties = {
      depth: format === 'h1' ? 1 : format === 'h2' ? 2 : format === 'h3' ? 3 : format === 'h4' ? 4 : format === 'h5' ? 5 : format === 'h6' ? 6 : 0,
      type: 'heading'
    };
  } else {
    newProperties = {
      // @ts-expect-error TODO
      type: isActive ? 'paragraph' : isList ? 'li' : format
    };
  }
  Transforms.setNodes(editor, newProperties);
  if (!isActive && isList) {
    var block = {
      type: format,
      children: []
    };
    Transforms.wrapNodes(editor, block);
  }
}
export function toggleMark(editor, format) {
  var isActive = isMarkActive(editor, format);
  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
}
function _getBlockOfType(editor, typeOrMatch) {
  var selection = editor.selection;
  if (!selection) return false;
  var _Array$from = Array.from(Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: function match(n) {
        return !Editor.isEditor(n) && SlateElement.isElement(n) && (typeof typeOrMatch === 'function' ? typeOrMatch(n) : n.type === typeOrMatch);
      }
    })),
    _Array$from2 = _slicedToArray(_Array$from, 1),
    match = _Array$from2[0];
  return match;
}
export function getBlockOfType(editor, typeOrMatch) {
  var result = _getBlockOfType(editor, typeOrMatch);
  return result ? result[0] : null;
}
export function isBlockActive(editor, typeOrMatch) {
  return !!_getBlockOfType(editor, typeOrMatch);
}
export function isMarkActive(editor, format) {
  var marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
}

/**
 * To reduce the likelihood of creating empty headings, let's ensure that
 * pressing "enter" while inside a heading creates a new paragraph instead
 *
 * @param editor The editor instance itself
 * @param event The keydown event on the editor
 */
export function escapeHeadingIfNeeded(editor, event) {
  var selection = editor.selection;
  if (!selection) {
    return;
  }
  if (event.key !== 'Enter') {
    return;
  }
  var _Array$from3 = Array.from(Editor.nodes(editor, {
      match: function match(node) {
        return SlateElement.isElement(node) && node.type === 'heading';
      }
    })),
    _Array$from4 = _slicedToArray(_Array$from3, 1),
    headingNodeEntry = _Array$from4[0];
  if (!headingNodeEntry) {
    return;
  }
  var endOfHeading = Editor.end(editor, headingNodeEntry[1]);
  var isAtEndOfHeading = Range.equals(selection, {
    anchor: endOfHeading,
    focus: endOfHeading
  });
  if (!isAtEndOfHeading) {
    return;
  }
  event.preventDefault();
  Transforms.insertNodes(editor, {
    type: 'paragraph',
    children: [{
      text: ''
    }]
  }, {
    match: function match(node) {
      return SlateElement.isElement(node) && node.type === 'heading';
    }
  });
}

/**
 * If shift+enter is pressed, adds a "soft" line-break as per the markdown
 * spec: https://spec.commonmark.org/0.31.2/#soft-line-breaks
 *
 * Soft line-breaks are rendered as a newline within the same paragraph. Our
 * Markdown renderer has `white-space: pre-line`, so it preserves the newlines
 * instead of collapsing them
 *
 * @param editor The editor instance itself
 * @param event The keydown event on the editor
 */
export function addSoftLineBreakIfNeeded(editor, event) {
  if (event.key === 'Enter' && event.shiftKey) {
    var isInHeading = !!Array.from(Editor.nodes(editor, {
      match: function match(node) {
        return SlateElement.isElement(node) && node.type === 'heading';
      }
    }))[0];

    // Shift+enter in headings doesn't seem to work, so let's just disable it
    // for now
    if (isInHeading) {
      event.preventDefault();
      return;
    }
    event.preventDefault();
    editor.insertText('\n');
  }
}

/**
 * Given a keyboard event, escapes the blockquote if cursor is at the end of the
 * blockquote and in an empty paragraph
 *
 * @param editor The editor instance itself
 * @param event The keydown event on the editor
 */
export function escapeBlockquoteIfNeeded(editor, event) {
  var selection = editor.selection;
  if (!selection) {
    return;
  }
  if (event.key !== 'Enter') {
    return;
  }
  var blockquoteNodeEntry = Array.from(Editor.nodes(editor, {
    match: function match(n) {
      return !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'blockquote';
    }
  }));
  if (blockquoteNodeEntry.length !== 1) {
    return;
  }
  var endOfBlockquote = Editor.end(editor, blockquoteNodeEntry[0][1]);
  var isAtEndOfBlockQuote = Range.equals(selection, {
    anchor: endOfBlockquote,
    focus: endOfBlockquote
  });
  var allNodes = Array.from(Editor.nodes(editor));
  var lastElement = allNodes[allNodes.length - 1][0];
  var secondLastElement = allNodes[allNodes.length - 2][0];
  var thirdLastElement = allNodes[allNodes.length - 3][0];
  var isInEmptyParagraph = 'text' in lastElement && lastElement.text === '' && 'type' in secondLastElement && secondLastElement.type === 'paragraph' && 'type' in thirdLastElement && thirdLastElement.type === 'blockquote';
  var shouldEscapeBlockquote = isInEmptyParagraph && isAtEndOfBlockQuote;
  if (!shouldEscapeBlockquote) {
    return;
  }
  event.preventDefault();
  Transforms.removeNodes(editor, {
    match: function match(node, path) {
      return SlateElement.isElement(node) && node.type === 'paragraph' && _isEqual(path, allNodes[allNodes.length - 2][1]);
    }
  });
  Transforms.insertNodes(editor, {
    type: 'paragraph',
    children: [{
      text: ''
    }]
  }, {
    match: function match(n) {
      return SlateElement.isElement(n) && n.type === 'blockquote';
    }
  });
}

/**
 * Given a keyboard event, escapes the list if cursor is at the end of the list in an empty list item
 *
 * @param editor The editor instance itself
 * @param event The keydown event on the editor
 */
export function escapeListIfNeeded(editor, event) {
  var selection = editor.selection;
  if (!selection) {
    return;
  }
  if (event.key !== 'Enter') {
    return;
  }
  if (event.shiftKey) {
    return;
  }
  var isInList = !!Array.from(Editor.nodes(editor, {
    match: function match(n) {
      return SlateElement.isElement(n) && LIST_TYPES.includes(n.type);
    }
  }))[0];
  if (!isInList) {
    return;
  }
  var endOfListItem = Editor.end(editor, selection.anchor.path);
  var isAtEndOfListItem = Range.equals(selection, {
    anchor: endOfListItem,
    focus: endOfListItem
  });
  var isAtStartOfNewline = Editor.string(editor, selection.anchor.path) === '';
  var shouldEscapeList = isAtEndOfListItem && isAtStartOfNewline;
  if (!shouldEscapeList) {
    return;
  }
  event.preventDefault();

  // Removes the `li` element
  Transforms.removeNodes(editor, {
    match: function match(n) {
      return SlateElement.isElement(n) && n.type === 'li';
    }
  });

  // Inserts a paragraph for the cursor to be after the list
  Transforms.insertNodes(editor, {
    type: 'paragraph',
    children: [{
      text: ''
    }]
  }, {
    match: function match(n) {
      return SlateElement.isElement(n) && LIST_TYPES.includes(n.type);
    }
  });
}

/**
 * Handles hotkeys for bold and italic text
 *
 * @param editor The editor instance itself
 * @param event The keydown event on the editor
 */
export function handleHotkeys(editor, event) {
  var HOTKEYS = {
    'mod+b': 'strong',
    'mod+i': 'emphasis',
    'mod+k': 'link'
  };
  for (var hotkey in HOTKEYS) {
    assert(hotkey === 'mod+b' || hotkey === 'mod+i' || hotkey === 'mod+k');
    if (isHotkey(hotkey, event)) {
      event.preventDefault();
      var mark = HOTKEYS[hotkey];
      if (mark === 'link') {
        toggleLink(editor);
      } else {
        toggleMark(editor, mark);
      }
    }
  }
}
/**
 * Converts an MDAST blockquote node to a Slate blockquote node,
 * taking into account the importance of the blockquote.
 */
export function convertRemarkBlockquoteToSlate(mdastNode, next) {
  var leafNode = mdastNode === null || mdastNode === void 0 ? void 0 : mdastNode.children[0];
  while (leafNode && _typeof(leafNode) === 'object' && 'children' in leafNode && isArray(leafNode.children)) {
    leafNode = leafNode.children[0];
  }
  var leafNodeText = leafNode && _typeof(leafNode) === 'object' && 'type' in leafNode && leafNode.type === 'text' && 'value' in leafNode && leafNode.value;
  if (typeof leafNodeText !== 'string') {
    return {
      children: next(mdastNode.children),
      type: 'blockquote'
    };
  }
  var annotationMatch = leafNodeText.match(/^\s*\[!(NOTE|TIP|WARNING|CAUTION)\](\n)?/i);
  if (!annotationMatch) {
    return {
      children: next(mdastNode.children),
      type: 'blockquote'
    };
  }
  var annotation = annotationMatch[0];
  var importance = annotation.toLowerCase().trim().replace('[!', '').replace(']', '').replace('\n', '');
  assert(_typeof(leafNode) === 'object' && leafNode && 'value' in leafNode && typeof leafNode.value === 'string');
  leafNode.value = leafNode.value.replace(annotation, '');
  return {
    children: next(mdastNode.children),
    importance: importance,
    type: 'blockquote'
  };
}

/**
 * Converts a slate blockquote node to an MDST blockquote node,
 * taking into account the importance of the blockquote.
 */
export function convertSlateBlockquoteToRemark(node, next) {
  if (!('importance' in node) || typeof node.importance !== 'string') {
    return {
      children: next(node.children),
      type: 'blockquote'
    };
  }
  var importance = node.importance.toUpperCase();
  assert(importance === 'NOTE' || importance === 'TIP' || importance === 'WARNING' || importance === 'CAUTION');
  return {
    children: next(produce(node.children, function (draft) {
      var leftmostNode = draft[0];
      while (isParentNode(leftmostNode)) {
        if (isSupportedTypeNode(leftmostNode)) {
          leftmostNode.children.unshift({
            text: "[!".concat(importance, "]\n")
          });
          return;
        }
        if (isTextNode(leftmostNode)) {
          leftmostNode.text = "[!".concat(importance, "]\n").concat(leftmostNode.text);
        }
        leftmostNode = leftmostNode.children[0];
      }
    })),
    type: 'blockquote'
  };
}
function isParentNode(node) {
  return !!node && _typeof(node) === 'object' && 'children' in node && isArray(node.children);
}
function isTextNode(node) {
  return _typeof(node) === 'object' && !!node && 'text' in node && typeof node.text === 'string';
}
function isSupportedTypeNode(node) {
  return _typeof(node) === 'object' && !!node && 'children' in node && isArray(node.children) && 'type' in node && (node.type === 'paragraph' || node.type === 'ul' || node.type === 'ol');
}
export function convertMarkdownStringToSlateTree(markdown) {
  var processor = unified().use(remarkParse).use(flattenListItemParagraphs).use(remarkToSlate, {
    overrides: {
      list: function list(node, next) {
        return {
          children: next(node.children),
          type: node.ordered ? 'ol' : 'ul'
        };
      },
      listItem: function listItem(node, next) {
        return {
          children: next(node.children),
          type: 'li'
        };
      },
      blockquote: convertRemarkBlockquoteToSlate
    }
  });
  var result = processor.processSync(markdown).result;
  return addEmptyParagraphsForTrailingNewlines(getInitialValue(result), markdown);
}

/**
 * Respect trailing newlines by appending an empty paragraph so the editor shows
 * a blank line on load. CommonMark ignores trailing blank lines at EOF, so we
 * emulate the intent here for UX.
 */
function addEmptyParagraphsForTrailingNewlines(slateTree, markdown) {
  var trailingNewlinesMatch = markdown.match(/\n+$/);
  var trailingNewlinesCount = trailingNewlinesMatch ? trailingNewlinesMatch[0].length : 0;
  var emptyParagraphsToAdd = Math.floor(trailingNewlinesCount / 2);
  var newSlateTree = _toConsumableArray(slateTree);
  for (var i = 0; i < emptyParagraphsToAdd; i++) {
    newSlateTree.push({
      type: 'paragraph',
      children: [{
        text: ''
      }]
    });
  }
  return newSlateTree;
}
function getInitialValue(value) {
  var fallbackValue = [{
    type: 'paragraph',
    children: [{
      text: ''
    }]
  }];
  if (!value || value.length === 0) {
    return fallbackValue;
  }
  if (value.length === 1) {
    var el = value[0];
    // @ts-expect-error Children should exist on Descendant?
    if (!el.children || el.children.length === 0) {
      return fallbackValue;
    }
  }
  return value;
}

// Taken from: https://gitlab.com/staltz/mdast-flatten-listitem-paragraphs
var flattenListItemParagraphs = function flattenListItemParagraphs() {
  return function (ast) {
    visit(ast, 'listItem', function (listItem) {
      if (isArray(listItem.children) && listItem.children.length === 1 && _typeof(listItem.children[0]) === 'object' && listItem.children[0] && 'type' in listItem.children[0] && listItem.children[0].type === 'paragraph' && 'children' in listItem.children[0]) {
        listItem.children = listItem.children[0].children;
      }
    });
    return ast;
  };
};
export function convertSlateTreeToMarkdownString(value) {
  var processor = unified().use(slateToRemark, {
    overrides: {
      ol: function ol(node, next) {
        assert(SlateElement.isElement(node));
        return {
          children: next(node.children),
          type: 'list',
          ordered: true
        };
      },
      ul: function ul(node, next) {
        assert(SlateElement.isElement(node));
        return {
          children: next(node.children),
          type: 'list',
          ordered: false
        };
      },
      li: function li(node, next) {
        assert(SlateElement.isElement(node));
        return {
          children: next(node.children),
          type: 'listItem'
        };
      },
      blockquote: function blockquote(node, next) {
        assert(SlateElement.isElement(node));
        return convertSlateBlockquoteToRemark(node, next);
      }
    }
  }).use(stringify);
  var mdastTree = processor.runSync({
    children: value,
    type: 'root'
  });
  var text = processor.stringify(mdastTree);
  return text;
}
export function getHeadingsConfig(powerFeatures) {
  var config = powerFeatures === null || powerFeatures === void 0 ? void 0 : powerFeatures.find(function (item) {
    return item === 'headings' || Array.isArray(item) && item[0] === 'headings';
  });
  if (config === 'headings') {
    return {
      maxLevel: 3,
      styles: {
        h1: undefined,
        h2: undefined,
        h3: undefined,
        h4: undefined,
        h5: undefined,
        h6: undefined
      }
    };
  }
  if (Array.isArray(config) && config[0] === 'headings') {
    assert(config[1].maxLevel <= 3, 'maxLevel must be less than or equal to 3');
    return config[1];
  }
  return null;
}
function unwrapLink(editor) {
  Transforms.unwrapNodes(editor, {
    match: function match(n) {
      return !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === 'link';
    }
  });
}
function wrapLink(editor, url) {
  if (isBlockActive(editor, 'link')) {
    unwrapLink(editor);
  }
  var selection = editor.selection;
  var isCollapsed = selection && Range.isCollapsed(selection);
  var link = {
    children: isCollapsed ? [{
      text: url
    }] : [],
    type: 'link',
    url: url
  };
  if (isCollapsed) {
    Transforms.insertNodes(editor, link);
  } else {
    Transforms.wrapNodes(editor, link, {
      split: true
    });
    Transforms.collapse(editor, {
      edge: 'end'
    });
  }
}
export function toggleLink(editor) {
  if (isBlockActive(editor, 'link')) {
    unwrapLink(editor);
  } else {
    var url = window.prompt('Enter the URL of the link:');
    if (!url) return;
    if (editor.selection) {
      wrapLink(editor, url);
    }
  }
}